import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  
  const programs = [
    {
      id: 1,
      title: 'Class',
      description: 'Enroll in our educational classes and skill development programs.',
      icon: '📚',
      link: '/class/center',
    },
    {
      id: 2,
      title: 'Camp',
      description: 'Join our exciting summer camps with activities for all age groups.',
      icon: '🏕️',
      link: '/camp/center',
    },
    {
      id: 3,
      title: 'Retreat',
      description: 'Experience spiritual growth and relaxation at our retreat programs.',
      icon: '🧘',
      link: '/retreat/center',
    },
    {
      id: 4,
      title: 'Tiffin',
      description: 'Order fresh, homemade meals from our tiffin service.',
      icon: '🍱',
      link: '/tiffin/menu',
    },
    {
      id: 5,
      title: 'Visitor',
      description: 'Register for a guided spiritual visit to our center.',
      icon: '🙏',
      link: '/yk-visit/center',
    },
    {
      id: 6,
      title: 'Email',
      description: 'Send bulk payment confirmation emails to multiple recipients.',
      icon: '📧',
      link: '/email',
    },
    {
      id: 7,
      title: 'Volunteer',
      description: 'Register to volunteer your time and seva at our centers.',
      icon: '🤝',
      link: '/volunteer/register',
    },
    {
      id: 8,
      title: 'Camp Volunteer',
      description: 'Volunteer at our Summer Camp and help create a memorable experience for kids.',
      icon: '🏕️🤝',
      link: '/volunteer/summer-camp',
    },
    {
      id: 9,
      title: 'Rentals',
      description: 'Book halls, spaces and facilities at Yugal Kunj for your events and programs.',
      icon: '🏛️',
      link: 'https://ykrentals.yugalkunj.org/',
      external: true,
    },
    {
      id: 10,
      title: 'Cooking Seva',
      description: 'Sign up to offer cooking seva and serve prasad at Yugal Kunj.',
      icon: '👩‍🍳',
      link: 'https://ykseva.yugalkunj.org/',
      external: true,
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Programs Section */}
      <section className="py-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {programs.map((program) => {
              const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
              const isEnabledTile = isProduction
                ? program.title === 'Class' || program.title === 'Retreat' || program.title === 'Tiffin' || program.title === 'Visitor' || program.title === 'Volunteer' || program.title === 'Camp Volunteer' || program.title === 'Rentals' || program.title === 'Cooking Seva'
                : program.title === 'Class' || program.title === 'Camp' || program.title === 'Retreat' || program.title === 'Email' || program.title === 'Tiffin' || program.title === 'Visitor' || program.title === 'Volunteer' || program.title === 'Camp Volunteer' || program.title === 'Rentals' || program.title === 'Cooking Seva';
              if (!isEnabledTile) return null;

              const handleClick = () => {
                if (program.external) window.open(program.link, '_blank', 'noopener,noreferrer');
                else navigate(program.link);
              };

              return (
                <div
                  key={program.id}
                  className="item-card p-6 text-center cursor-pointer"
                  onClick={handleClick}
                >
                  <div className="text-6xl mb-4">{program.icon}</div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{program.title}</h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-4">{program.description}</p>
                  {isEnabledTile && (
                    <div className="mt-auto">
                      <div className="bg-white hover:bg-gray-50 text-gray-700 font-semibold py-3 px-5 rounded-full border-2 border-gray-200 transition shadow-sm hover:shadow-md text-base">
                        Explore
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
